import './index.scss';
import React, { useEffect } from 'react';
import { TabBar } from 'antd-mobile';
import recommandIcon from '@/images/ico_tab_recommand.png';
import recommandSelectedIcon from '@/images/ico_tab_recommand_selected.png';
import schoolIcon from '@/images/ico_tab_school.png';
import schoolSelectedIcon from '@/images/ico_tab_school_selected.png';
import loactionIcon from '@/images/ico_tab_location.png';
import loactionSelectedIcon from '@/images/ico_tab_location_selected.png';
import demo1 from '@/images/bg_demo1.png';
import demo2 from '@/images/bg_demo2.png';
import demo3 from '@/images/bg_demo3.png';
import sysConfig from '@/sysConfig';

import cover1 from '@/images/demonstrationCover/cover1.png';
import cover1_2 from '@/images/demonstrationCover/cover1-2.png';
import cover1_3 from '@/images/demonstrationCover/cover1-3.png';
import cover2 from '@/images/demonstrationCover/cover2.png';
import cover3 from '@/images/demonstrationCover/cover3.png';
import cover4 from '@/images/demonstrationCover/cover4.png';
import cover5 from '@/images/demonstrationCover/cover5.png';
import cover6 from '@/images/demonstrationCover/cover6.png';
import cover7 from '@/images/demonstrationCover/cover7.png';
import cover8 from '@/images/demonstrationCover/cover8.png';
import cover9 from '@/images/demonstrationCover/cover9.png';
import cover10 from '@/images/demonstrationCover/cover10.png';

const TabBarIcon = ({ icon }) => {
  const iconSize = { width: '5.42vw', height: '5.42vw' };

  return (
    <div
      style={{
        ...iconSize,
        background: `url(${icon}) center center /  100% auto no-repeat`,
      }}
    />
  );
};

const DemoContent = ({ img, children }) => {
  return (
    <div className="demo-content">
      <img src={img} alt="demo" />
      {children}
    </div>
  );
};

const ResList = ({ data = [] }) => {
  return (
    <div className="demo-res-list">
      {data.map((item) => (
        <div className="res-item">
          <a href={item.link}>
            <div className="res-item-cover">
              <img src={item.cover} alt={item.title} />
            </div>
            <span className="res-item-title">{item.title}</span>
          </a>
        </div>
      ))}
    </div>
  );
};

const Demonstration = ({
  match: {
    params: { tab },
  },
}) => {
  const tarBarData = [
    {
      title: '推荐资源',
      key: 'recommand-res',
      icon: recommandIcon,
      selectedIcon: recommandSelectedIcon,
      demo: demo1,
      resData: [
        {
          title: '踏雪寻梅',
          cover: cover1,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
        {
          title: '简笔画人',
          cover: cover2,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/6/23/30/540476/428183664b5d668b72c3140f9cdeb6d6.mp4/mp4/transform.mp4',
        },
        {
          title: '童心是小鸟',
          cover: cover3,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/5/19/35/540476/bf715e009b329c77db4fa28212238fbc.mp4/mp4/transform.mp4',
        },
        {
          title: '阿里里',
          cover: cover4,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/20/10/17/540476/a062565756f59554f11bcb2b316b2118.mp4/mp4/transform.mp4',
        },
        {
          title: '如今家乡山连山',
          cover: cover5,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/19/17/20/540476/899d781d1efa308fa84682924ebddac0.mp4/mp4/transform.mp4',
        },
        {
          title: '小蚂蚁',
          cover: cover6,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/19/14/40/540476/bb2d600c94f6ce653eff411892d7da84.mp4/mp4/transform.mp4',
        },
        {
          title: '青花瓷',
          cover: cover7,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/18/9/45/540476/1de9b453edde0d5bdbdc2912bb13e52e.mp4/mp4/transform.mp4',
        },
        {
          title: '花球操',
          cover: cover8,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/17/20/25/540476/9594ab9ed3a65622708d40878b7a1e87.mp4/mp4/transform.mp4',
        },
        {
          title: '小花伞',
          cover: cover9,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2021/12/17/15/28/540476/55012920cd9bc5498ac02b6c57ab2a14.mp4/mp4/transform.mp4',
        },
        {
          title: '母鸡叫咯咯',
          cover: cover10,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2021/12/18/3/20/540476/12c5bdb7c183f3d520c24fa68cabf819.mp4/mp4/transform.mp4',
        },
      ],
    },
    {
      title: '本校资源',
      key: 'school-res',
      icon: schoolIcon,
      selectedIcon: schoolSelectedIcon,
      demo: demo2,
      resData: [
        {
          title: '踏雪寻梅',
          cover: cover1_2,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/6/23/30/540476/428183664b5d668b72c3140f9cdeb6d6.mp4/mp4/transform.mp4',
        },
        {
          title: '简笔画人',
          cover: cover2,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
        {
          title: '童心是小鸟',
          cover: cover3,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/5/19/35/540476/bf715e009b329c77db4fa28212238fbc.mp4/mp4/transform.mp4',
        },
        {
          title: '阿里里',
          cover: cover4,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/6/23/30/540476/428183664b5d668b72c3140f9cdeb6d6.mp4/mp4/transform.mp4',
        },
        {
          title: '如今家乡山连山',
          cover: cover5,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
        {
          title: '小蚂蚁',
          cover: cover6,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/5/19/35/540476/bf715e009b329c77db4fa28212238fbc.mp4/mp4/transform.mp4',
        },
        // { title: '青花瓷', cover: cover7, link: '' },
        // { title: '花球操', cover: cover8, link: '' },
        {
          title: '小花伞',
          cover: cover9,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/6/23/30/540476/428183664b5d668b72c3140f9cdeb6d6.mp4/mp4/transform.mp4',
        },
        {
          title: '母鸡叫咯咯',
          cover: cover10,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
      ],
    },
    {
      title: '区域资源',
      key: 'loacl-res',
      icon: loactionIcon,
      selectedIcon: loactionSelectedIcon,
      demo: demo3,
      resData: [
        {
          title: '踏雪寻梅',
          cover: cover1_3,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/5/19/35/540476/bf715e009b329c77db4fa28212238fbc.mp4/mp4/transform.mp4',
        },
        {
          title: '简笔画人',
          cover: cover2,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
        {
          title: '童心是小鸟',
          cover: cover3,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/6/23/30/540476/428183664b5d668b72c3140f9cdeb6d6.mp4/mp4/transform.mp4',
        },
        {
          title: '阿里里',
          cover: cover4,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/5/19/35/540476/bf715e009b329c77db4fa28212238fbc.mp4/mp4/transform.mp4',
        },
        {
          title: '如今家乡山连山',
          cover: cover5,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
        {
          title: '小蚂蚁',
          cover: cover6,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/6/23/30/540476/428183664b5d668b72c3140f9cdeb6d6.mp4/mp4/transform.mp4',
        },
        // { title: '青花瓷', cover: cover7, link: '' },
        // { title: '花球操', cover: cover8, link: '' },
        {
          title: '小花伞',
          cover: cover9,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/5/19/35/540476/bf715e009b329c77db4fa28212238fbc.mp4/mp4/transform.mp4',
        },
        {
          title: '母鸡叫咯咯',
          cover: cover10,
          link:
            'http://res.nbsedu.com:20000//data17/transform/2022/1/16/0/3/540476/6ac3286312e11b79bc9b48517769c498.mp4/mp4/transform.mp4',
        },
      ],
    },
  ];

  useEffect(() => {
    document.title = '随时学2.0';
  }, [tarBarData]);

  return (
    <div className="demonstration">
      <TabBar unselectedTintColor="#9A9B9D" tintColor="#040404" barTintColor="#EFF0F2">
        {tarBarData.map((item) => (
          <TabBar.Item
            title={item.title}
            key={item.key}
            icon={<TabBarIcon icon={item.icon} />}
            selectedIcon={<TabBarIcon icon={item.selectedIcon} />}
            selected={tab === item.key}
            onPress={() => {
              window.open(
                `${window.location.protocol}//${window.location.host}${sysConfig.preRouteUrl}/demonstration/${item.key}`,
                '_self',
              );
            }}
          >
            <DemoContent img={item.demo}>
              <ResList data={item.resData} />
            </DemoContent>
          </TabBar.Item>
        ))}
      </TabBar>
    </div>
  );
};

export default Demonstration;
